import React from 'react'
import search from '../../assets/icons/search.svg'

const SearchBox = ({ searchTerm, setSearchTerm, placeholder, width='w300' }) => {
  
  const handleChange = event => {
    setSearchTerm(event.target.value)
  }

  return (
    <div className={width}>
      <div className='op.5 posa ml5 mt10 mr30'>
        <img 
          alt={'search glass'}
          className=''
          src={search}/>
      </div>
      <input
        className="dib oln bd1-s-lightgray fz15 pl40"
        type="text"
        placeholder={placeholder || ''}
        value={searchTerm}
        onChange={handleChange}></input>
    </div>
  )
}

export default SearchBox